export const formatExperienceDuration = (
  fromDate,
  toDate,
  isCurrent
) => {
  if (!fromDate) return "-";

  const start = new Date(fromDate);
  const end = isCurrent || !toDate ? new Date() : new Date(toDate);

  // Month Year format
  const formatMonthYear = (date) =>
    date.toLocaleString("en-US", {
      month: "short",
      year: "numeric",
    });

  const startLabel = formatMonthYear(start);
  const endLabel = isCurrent || !toDate
    ? "Present"
    : formatMonthYear(end);

  // Calculate duration
  let years = end.getFullYear() - start.getFullYear();
  let months = end.getMonth() - start.getMonth();

  if (months < 0) {
    years--;
    months += 12;
  }

  let duration = "";
  if (years > 0) duration += `${years} Year${years > 1 ? "s" : ""}`;
  if (months > 0)
    duration += `${years > 0 ? " " : ""}${months} Month${months > 1 ? "s" : ""}`;

  if (!duration) duration = "Less than a month";

  return `${startLabel} - ${endLabel} • ${duration}`;
};


export const formatDate = (date) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(date).toLocaleDateString(undefined, options);
};
export const formatMomentDate = (date, format = "DD MMM YYYY") => {
  if (!date) return "-";
  
  const d = new Date(date);
  if (isNaN(d.getTime())) return "-";

  const pad = (num, size = 2) => String(num).padStart(size, '0');

  const monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const monthsFull = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  
  const year = d.getFullYear();
  const month = d.getMonth();
  const day = d.getDate();
  const hours24 = d.getHours();
  const minutes = d.getMinutes();
  const seconds = d.getSeconds();

  const isPM = hours24 >= 12;
  const hours12 = hours24 % 12 || 12;

  const map = {
    "YYYY": year,
    "YY": String(year).slice(-2),
    "MMMM": monthsFull[month],
    "MMM": monthsShort[month],
    "MM": pad(month + 1),
    "M": month + 1,
    "DD": pad(day),
    "D": day,
    "HH": pad(hours24),
    "H": hours24,
    "hh": pad(hours12),
    "h": hours12,
    "mm": pad(minutes),
    "m": minutes,
    "ss": pad(seconds),
    "s": seconds,
    "A": isPM ? "PM" : "AM",
    "a": isPM ? "pm" : "am",
  };

  const regex = new RegExp(Object.keys(map).sort((a, b) => b.length - a.length).join("|"), "g");
  return format.replace(regex, (matched) => map[matched]);
};

export const fromNow = (date) => {
  if (!date) return "-";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "-";
  
  const now = new Date();
  const seconds = Math.floor((now - d) / 1000);
  
  if (seconds < 5) return "just now";
  if (seconds < 60) return `${seconds} seconds ago`;
  
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return minutes === 1 ? "1 minute ago" : `${minutes} minutes ago`;
  
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
  
  const days = Math.floor(hours / 24);
  if (days < 30) return days === 1 ? "1 day ago" : `${days} days ago`;
  
  const months = Math.floor(days / 30);
  if (months < 12) return months === 1 ? "1 month ago" : `${months} months ago`;
  
  const years = Math.floor(months / 12);
  return years === 1 ? "1 year ago" : `${years} years ago`;
};